document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.mk-header-container');
    const searchToggles = document.querySelectorAll('.mk-search-toggle');
    const mobileMenuToggles = document.querySelectorAll('.mk-mobile-menu-toggle');
    const filterSortContainer = document.querySelector('.mk-filter-sort-button-container');
    const breadcrumbs = document.querySelector('.mk-breadcrumbs');
    const collectionGrid = document.querySelector('.mk-collection-grid, .anchors-trigger');
    const collectionAnchor = document.querySelector('.mk-collection-anchor');
    const backToTopButton = document.querySelector('.back-to-top-button');
    let prevScrollPos = window.pageYOffset;

    // Mobile menu open/close functionality
    if (mobileMenuToggles.length) {
        mobileMenuToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                // Always remove search-open when mobile menu is toggled
                document.body.classList.remove('search-open');
                document.body.classList.toggle('mobile-menu-open');
          setMobileMenuRootState();
            });
        });
    }

    function checkScroll() {
      if (!header) return;
      const currentScrollPos = window.pageYOffset;
      const scrollDifference = prevScrollPos - currentScrollPos;
      
      // Check if we're at the bottom of the page
      const documentHeight = Math.max(
        document.body.scrollHeight, 
        document.body.offsetHeight, 
        document.documentElement.clientHeight, 
        document.documentElement.scrollHeight, 
        document.documentElement.offsetHeight
      );
      const windowHeight = window.innerHeight;
      const isAtBottom = (currentScrollPos + windowHeight) >= (documentHeight - 10); // 10px buffer

      // Collection anchor visibility
      if (collectionGrid && collectionAnchor) {
        const gridRect = collectionGrid.getBoundingClientRect();
        const isFooterBlack = document.body.classList.contains('bg-grey');
        
        // Check if footer is in viewport
        const footerWrapper = document.querySelector('.mk-footer-wrapper');
        let footerInViewport = false;
        
        if (footerWrapper) {
          const isFooterVisible = window.getComputedStyle(footerWrapper).display !== 'none';
          if (isFooterVisible) {
            const footerRect = footerWrapper.getBoundingClientRect();
            footerInViewport = footerRect.top < windowHeight;
          }
        }
        
        if (gridRect.top < 0 && !isFooterBlack && !footerInViewport) {
          collectionAnchor.classList.add('mk-collection-anchor--show');
          if (backToTopButton) {
            backToTopButton.classList.add('back-to-top-button--show');
          }
        } else {
          collectionAnchor.classList.remove('mk-collection-anchor--show');
          if (backToTopButton) {
            backToTopButton.classList.remove('back-to-top-button--show');
          }
        }
      }

      // Add sticky class when scrolling up more than 10px and past 25px, but NOT when at bottom or within 25px of top
      if (scrollDifference > 10 && currentScrollPos > 25 && !isAtBottom) {
        document.body.classList.add('header-sticky');
        if (filterSortContainer) {
          filterSortContainer.classList.add('mk-filter-sort-button-container--sticky');
        }
        if (breadcrumbs) {
          breadcrumbs.classList.add('mk-breadcrumbs--sticky');
        }
        if (collectionAnchor) {
          collectionAnchor.classList.add('mk-collection-anchor--sticky');
        }
      } else if (scrollDifference < -2 || isAtBottom || currentScrollPos <= 25) {
        // Remove when scrolling down more than 10px OR when at bottom OR within 25px of top
        document.body.classList.remove('header-sticky');
        if (filterSortContainer) {
          filterSortContainer.classList.remove('mk-filter-sort-button-container--sticky');
        }
        if (breadcrumbs) {
          breadcrumbs.classList.remove('mk-breadcrumbs--sticky');
        }
        if (collectionAnchor) {
          collectionAnchor.classList.remove('mk-collection-anchor--sticky');
        }
      }

      prevScrollPos = currentScrollPos;
    }

    window.addEventListener('scroll', checkScroll);
    checkScroll();

    // Listen for pagination events to sync anchor with footer visibility
    if (collectionAnchor) {
      window.addEventListener('paginationLoadStart', checkScroll);
      window.addEventListener('paginationComplete', checkScroll);
    }

    if (header && searchToggles.length) {
      searchToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          // Always remove mobile-menu-open when search is toggled
          document.body.classList.remove('mobile-menu-open');
          document.body.classList.toggle('search-open');
          const searchInput = document.querySelector('input[type="search"], input[type="text"].search-input');
          if (document.body.classList.contains('search-open') && searchInput) {
            setTimeout(() => {
              searchInput.focus({ preventScroll: true });
            }, 10);
          }
        });
      });
    }

    const headerItems = document.querySelectorAll('.mk-header-item');
    const headerToggleItems = document.querySelectorAll('.mk-header-item--toggle');
    const headerSectionLeft = document.querySelector('.mk-header-section--left');
    const headerSectionRight = document.querySelector('.mk-header-section--right');

    // Calculate and set menu background heights to the tallest menu
    function calculateMenuHeights() {
      let maxHeight = 0;
      
      // Find the tallest menu across all toggle items
      headerToggleItems.forEach(toggleItem => {
        const menu = toggleItem.querySelector('.mk-header-item-menu');
        if (menu) {
          const menuHeight = menu.offsetHeight;
          if (menuHeight > maxHeight) {
            maxHeight = menuHeight;
          }
        }
      });
      
      const totalHeight = maxHeight;
      
      // Set the shared backgrounds (one per section) to the maximum height
      const leftBackground = headerSectionLeft?.querySelector('.mk-header-item-menu-background');
      const rightBackground = headerSectionRight?.querySelector('.mk-header-item-menu-background');
      
      if (leftBackground) {
        leftBackground.style.height = totalHeight + 'px';
        leftBackground.style.marginTop = '-' + totalHeight + 'px';
        leftBackground.style.setProperty('--translate-distance', totalHeight + 'px');
      }
      if (rightBackground) {
        rightBackground.style.height = totalHeight + 'px';
        rightBackground.style.marginTop = '-' + totalHeight + 'px';
        rightBackground.style.setProperty('--translate-distance', totalHeight + 'px');
      }
    }

    // Call on load
    calculateMenuHeights();
    
    // Recalculate on window resize
    window.addEventListener('resize', calculateMenuHeights);

    function updateMenuOpenClass() {
      if (!headerSectionLeft) return;
      const anyActive = Array.from(headerToggleItems).some(i => i.classList.contains('active'));
      if (anyActive) {
        headerSectionLeft.classList.add('mk-header-section--menu-open');
        document.body.classList.add('menu-open');
        
        // Add the no-delay class after the initial animation
        setTimeout(() => {
          if (headerSectionLeft.classList.contains('mk-header-section--menu-open')) {
            headerSectionLeft.classList.add('mk-header-section--menu-opened');
          }
        }, 100);
      } else {
        headerSectionLeft.classList.remove('mk-header-section--menu-open');
        headerSectionLeft.classList.remove('mk-header-section--menu-opened');
        document.body.classList.remove('menu-open');
      }
    }

    headerItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        // If this item is NOT a toggle, close all menus
        if (!item.classList.contains('mk-header-item--toggle')) {
          headerToggleItems.forEach(i => i.classList.remove('active'));
          updateMenuOpenClass();
        } else {
          // Only change active if this isn't already the active one
          if (!item.classList.contains('active')) {
            headerToggleItems.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
            updateMenuOpenClass();
          }
        }
      });
    });

    if (headerSectionLeft) {
      headerSectionLeft.addEventListener('mouseleave', function(e) {
        // Only close if not moving to the right section
        setTimeout(() => {
          if (!headerSectionRight?.matches(':hover') && !headerSectionLeft?.matches(':hover')) {
            headerToggleItems.forEach(i => i.classList.remove('active'));
            updateMenuOpenClass();
          }
        }, 10);
      });
    }

    if (headerSectionRight) {
      headerSectionRight.addEventListener('mouseleave', function(e) {
        // Only close if not moving to the left section
        setTimeout(() => {
          if (!headerSectionRight?.matches(':hover') && !headerSectionLeft?.matches(':hover')) {
            headerToggleItems.forEach(i => i.classList.remove('active'));
            updateMenuOpenClass();
          }
        }, 10);
      });
    }

    // Mobile menu title/list toggle functionality
    const mobileBackLabel = document.querySelector('[data-mobile-menu-back]');
    const mobileBackText = document.querySelector('.mk-mobile-menu-back-text');
    const mobileRootList = document.querySelector('.mk-mobile-menu-list--root');
    const mobileParentLinks = document.querySelectorAll('[data-mobile-menu-parent]');
    const mobileSubLists = document.querySelectorAll('.mk-mobile-menu-list--sub');

    function setMobileMenuRootState() {
      if (!mobileBackLabel || !mobileRootList) {
        return;
      }

      mobileBackLabel.classList.remove('is-back');
      if (mobileBackText) {
        mobileBackText.textContent = 'Shop';
      }
      mobileRootList.classList.add('open');
      mobileSubLists.forEach(list => list.classList.remove('open'));
    }

    function setMobileMenuSubState(index, title) {
      const subList = document.querySelector(`.mk-mobile-menu-list--sub[data-mobile-menu-sub="${index}"]`);

      if (!mobileBackLabel || !mobileRootList || !subList) {
        return;
      }

      mobileBackLabel.classList.add('is-back');
      if (mobileBackText) {
        mobileBackText.textContent = title;
      }
      mobileRootList.classList.remove('open');
      mobileSubLists.forEach(list => list.classList.remove('open'));
      subList.classList.add('open');
    }

    mobileBackLabel?.addEventListener('click', function() {
      if (mobileRootList && !mobileRootList.classList.contains('open')) {
        setMobileMenuRootState();
      }
    });

    mobileParentLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        setMobileMenuSubState(link.dataset.mobileMenuParent, link.textContent.trim());
      });
    });

    setMobileMenuRootState();

    // Check if at top of page
    function checkScrollPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Check if we're within 50px of the top
      const isAtTop = scrollTop <= 0;
      
      if (isAtTop) {
        document.body.classList.add('mk-top');
      } else {
        document.body.classList.remove('mk-top');
      }
    }

    // Check on scroll
    window.addEventListener('scroll', checkScrollPosition, { passive: true });
    
    // Check on page load
    checkScrollPosition();
    
    // Check on resize
    window.addEventListener('resize', checkScrollPosition, { passive: true });
});